/* Slider semplice con frecce e puntini */
if (!customElements.get('sm-slider')) {
  customElements.define(
    'sm-slider',
    class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.prev = this.querySelectorAll('[data-prev]');
        this.next = this.querySelectorAll('[data-next]');
        this.dots = this.querySelector('[data-dots]');
        this.prev.forEach((b) => b.addEventListener('click', () => this.go(-1)));
        this.next.forEach((b) => b.addEventListener('click', () => this.go(1)));
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        window.addEventListener('resize', () => this.update());
        if (this.dots) this.buildDots();
        this.update();
        if (this.dataset.autoplay) {
          const ms = parseInt(this.dataset.autoplay, 10) * 1000;
          this._t = setInterval(() => {
            if (this.matches(':hover')) return;
            const end = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;
            end ? this.track.scrollTo({ left: 0 }) : this.go(1);
          }, ms);
        }
      }
      disconnectedCallback() {
        clearInterval(this._t);
      }
      step() {
        const item = this.track.children[0];
        if (!item) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return item.getBoundingClientRect().width + gap;
      }
      go(dir) {
        this.track.scrollBy({ left: dir * this.step(), behavior: 'smooth' });
      }
      buildDots() {
        this.dots.innerHTML = '';
        [...this.track.children].forEach((_, i) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'sm-dot';
          b.setAttribute('aria-label', String(i + 1));
          b.addEventListener('click', () => this.track.scrollTo({ left: i * this.step(), behavior: 'smooth' }));
          this.dots.appendChild(b);
        });
      }
      update() {
        const t = this.track;
        const atStart = t.scrollLeft <= 4;
        const atEnd = t.scrollLeft + t.clientWidth >= t.scrollWidth - 4;
        if (!this.hasAttribute('data-loop')) {
          this.prev.forEach((b) => (b.disabled = atStart));
          this.next.forEach((b) => (b.disabled = atEnd));
        }
        if (this.dots) {
          const i = Math.round(t.scrollLeft / this.step());
          [...this.dots.children].forEach((d, n) => d.classList.toggle('is-active', n === i));
        }
      }
    }
  );
}

/* Tabs collezioni in homepage */
if (!customElements.get('sm-tabs')) {
  customElements.define(
    'sm-tabs',
    class extends HTMLElement {
      connectedCallback() {
        this.buttons = this.querySelectorAll('[role="tab"]');
        this.panels = this.querySelectorAll('[role="tabpanel"]');
        this.buttons.forEach((btn, i) =>
          btn.addEventListener('click', () => {
            this.buttons.forEach((b, n) => b.setAttribute('aria-selected', n === i ? 'true' : 'false'));
            this.panels.forEach((p, n) => (p.hidden = n !== i));
          })
        );
      }
    }
  );
}

/* Data di consegna stimata (giorni di calendario, weekend incluso) */
document.querySelectorAll('[data-sm-delivery]').forEach((el) => {
  const min = parseInt(el.dataset.min, 10) || 2;
  const max = parseInt(el.dataset.max, 10) || min;
  const addDays = (d, n) => {
    const date = new Date(d);
    date.setDate(date.getDate() + n);
    return date;
  };
  const fmt = (d) =>
    d
      .toLocaleDateString(el.dataset.locale || 'it-IT', { weekday: 'short', day: 'numeric', month: 'short' })
      .replace(/\./g, '');
  const a = addDays(new Date(), min);
  const b = addDays(new Date(), max);
  el.textContent = min === max ? fmt(a) : fmt(a) + ' - ' + fmt(b);
});

/* Timer carrello */
if (!customElements.get('sm-cart-timer')) {
  customElements.define(
    'sm-cart-timer',
    class extends HTMLElement {
      connectedCallback() {
        const KEY = 'smCartTimerEnd';
        const duration = (parseInt(this.dataset.minutes, 10) || 10) * 60 * 1000;
        let end = 0;
        try {
          end = parseInt(sessionStorage.getItem(KEY), 10) || 0;
        } catch (e) {}
        if (!end || end < Date.now()) {
          end = Date.now() + duration;
          try {
            sessionStorage.setItem(KEY, String(end));
          } catch (e) {}
        }
        const out = this.querySelector('[data-sm-time]');
        const tick = () => {
          const left = Math.max(0, Math.round((end - Date.now()) / 1000));
          const m = Math.floor(left / 60);
          const s = left % 60;
          if (out) out.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
          return left;
        };
        tick();
        this._t = setInterval(() => {
          if (tick() === 0) clearInterval(this._t);
        }, 1000);
      }
      disconnectedCallback() {
        clearInterval(this._t);
      }
    }
  );
}

/* Extra carrello: timer, scaglioni, risparmio, pagamenti */
(function () {
  const source = () => document.getElementById('SmCartExtras');
  let busy = false;

  const part = (name) => {
    const src = source();
    const el = src && src.querySelector('[data-part="' + name + '"]');
    if (!el || !el.innerHTML.trim()) return null;
    const wrap = document.createElement('div');
    wrap.setAttribute('data-sm-injected', name);
    wrap.innerHTML = el.innerHTML;
    return wrap;
  };

  function inject() {
    if (busy || !source()) return;
    busy = true;
    document.querySelectorAll('[data-sm-injected]').forEach((n) => n.remove());

    const drawer = document.querySelector('#CartDrawer .drawer__inner');
    if (drawer) {
      const header = drawer.querySelector('.drawer__header');
      if (header && !drawer.classList.contains('is-empty')) {
        const tiers = part('tiers');
        const timer = part('timer');
        if (tiers) header.after(tiers);
        if (timer) header.after(timer);
      }
      const footer = drawer.querySelector('.cart-drawer__footer');
      const savings = part('savings');
      if (footer && savings) footer.prepend(savings);
      const ctas = drawer.querySelector('.cart__ctas');
      const trust = part('trust');
      if (ctas && trust) ctas.after(trust);
      const empty = drawer.querySelector('.cart-drawer__empty-content');
      const icon = part('emptyicon');
      if (empty && icon) empty.prepend(icon);
    }

    const page = document.querySelector('.cart__footer-wrapper, #main-cart-footer');
    if (page) {
      const items = document.querySelector('#main-cart-items .js-contents');
      if (items && items.querySelector('.cart-items')) {
        const tiers = part('tiers');
        const timer = part('timer');
        if (tiers) items.prepend(tiers);
        if (timer) items.prepend(timer);
      }
      const totals = page.querySelector('.js-contents');
      const savings = part('savings');
      if (totals && savings) totals.prepend(savings);
      const ctas = page.querySelector('.cart__ctas');
      const trust = part('trust');
      if (ctas && trust) ctas.after(trust);
    }
    setTimeout(() => (busy = false), 0);
  }

  async function refresh() {
    const src = source();
    if (!src) return;
    const wrapper = src.closest('.shopify-section');
    if (!wrapper) return inject();
    const id = wrapper.id.replace('shopify-section-', '');
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const res = await fetch(root + '?sections=' + encodeURIComponent(id));
      const data = await res.json();
      const doc = new DOMParser().parseFromString(data[id], 'text/html');
      const fresh = doc.getElementById('SmCartExtras');
      if (fresh) src.innerHTML = fresh.innerHTML;
    } catch (e) {}
    inject();
  }

  function init() {
    inject();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(refresh, 50));
    }
    const watch = (sel) => {
      const el = document.querySelector(sel);
      if (!el) return;
      let t;
      new MutationObserver(() => {
        if (busy) return;
        clearTimeout(t);
        t = setTimeout(() => {
          const missing =
            (document.querySelector('#CartDrawer .drawer__header') && !document.querySelector('#CartDrawer [data-sm-injected]')) ||
            (document.querySelector('#main-cart-footer .cart__ctas') && !document.querySelector('#main-cart-footer [data-sm-injected]'));
          if (missing) refresh();
        }, 60);
      }).observe(el, { childList: true, subtree: true });
    };
    watch('#CartDrawer');
    watch('#main-cart-footer');
    watch('#main-cart-items');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Badge con percentuale di sconto */
(function () {
  const S = window.smStrings || {};
  const num = (el) => {
    if (!el) return 0;
    const d = el.textContent.replace(/[^\d]/g, '');
    return d ? parseInt(d, 10) : 0;
  };
  const pctOf = (scope) => {
    const sale = scope.querySelector('.price--on-sale .price__sale .price-item--sale');
    const reg = scope.querySelector('.price--on-sale .price__sale .price-item--regular');
    const s = num(sale);
    const r = num(reg);
    return r > s && s > 0 ? Math.round(((r - s) / r) * 100) : 0;
  };
  const label = (p) => (S.percentOff || '[n]% di sconto').replace('[n]', p);
  let running = false;

  function run() {
    if (running) return;
    running = true;
    document.querySelectorAll('.card-wrapper').forEach((card) => {
      const p = pctOf(card);
      if (!p) return;
      card.querySelectorAll('.card__badge .badge').forEach((b) => {
        const txt = b.textContent.trim();
        if (txt === S.onSale && txt !== label(p)) b.textContent = label(p);
      });
    });
    document.querySelectorAll('.price').forEach((price) => {
      const badge = price.querySelector('.price__badge-sale');
      if (!badge) return;
      const p = pctOf(price.parentElement || price);
      if (p && badge.textContent.trim() !== label(p)) badge.textContent = label(p);
    });
    running = false;
  }

  const start = () => {
    run();
    let t;
    new MutationObserver(() => {
      clearTimeout(t);
      t = setTimeout(run, 80);
    }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
